import React, { useEffect } from "react";
import './technologys.scss';
import {techs} from './helper.tsx'
import ScrollReveal from 'scrollreveal';
import splineImage from "../../Assets/Spline.png"
import rebelmoon from "../../Assets/rebelmoon.png"
const Technology = () => {
    useEffect(() => {
        // Initialize ScrollReveal with desired configuration
        ScrollReveal().reveal('.reveal', {
          // Configuration options
          distance: '50px',
          duration: 1000,
          easing: 'ease-in-out',
          origin: 'bottom',
          reset: true,
        });
      }, []); // Empty dependency array ensures this runs only once
    return (
        <div className="tech-container skills">
            <div className="container-1">
        <div className="techs">
            <div className="large heading reveal">Work Experience</div>
            <div className="container">
                {techs.map((tech, index) => (
                    <div key={index} className="tech-item reveal">
                        <div className="tech-icon" title={tech.name}>{tech.svg}</div>
                    </div>
                ))}
                    <div  className="tech-item reveal">
                      
                        <img src="https://spline.design/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fspline_logo.647803e0.png&w=64&q=75"  className="tech-icon" title="Spline" />
                    </div>
            </div>
         
        </div></div>
        <div className="container-2  works">
                <div className="head bold reveal">
                    Work Samples
                </div>
                <div className="work-samples">
                    <div className="sample-card">
                        <div className="image reveal">
                            <a target="blank" href="https://spline-learning-60031592404.development.catalystserverless.in/app/index.html" >
                        <img src={splineImage}></img></a>
                        </div>
                        <div className="content reveal">
                            <div className="title bold">
                                Bottle Ad
                            </div>
                            <div className="text light">
                            I've crafted a small UI design in React featuring spline 3D for a bottle advertisement, combining smooth, curved surfaces for a realistic look. This integrates technical prowess with creative marketing to enhance user engagement effectively.
                            </div>
                            <div className="techs-images">
                                            <span title="React" className="tech-span">
                                           <svg xmlns="http://www.w3.org/2000/svg" className="tech-image tech-icon" viewBox="0 0 128 128"><g fill="#61DAFB"><circle cx="64" cy="64" r="11.4"/><path d="M107.3 45.2c-2.2-.8-4.5-1.6-6.9-2.3.6-2.4 1.1-4.8 1.5-7.1 2.1-13.2-.2-22.5-6.6-26.1-1.9-1.1-4-1.6-6.4-1.6-7 0-15.9 5.2-24.9 13.9-9-8.7-17.9-13.9-24.9-13.9-2.4 0-4.5.5-6.4 1.6-6.4 3.7-8.7 13-6.6 26.1.4 2.3.9 4.7 1.5 7.1-2.4.7-4.7 1.4-6.9 2.3C8.2 50 1.4 56.6 1.4 64s6.9 14 19.3 18.8c2.2.8 4.5 1.6 6.9 2.3-.6 2.4-1.1 4.8-1.5 7.1-2.1 13.2.2 22.5 6.6 26.1 1.9 1.1 4 1.6 6.4 1.6 7.1 0 16-5.2 24.9-13.9 9 8.7 17.9 13.9 24.9 13.9 2.4 0 4.5-.5 6.4-1.6 6.4-3.7 8.7-13 6.6-26.1-.4-2.3-.9-4.7-1.5-7.1 2.4-.7 4.7-1.4 6.9-2.3 12.5-4.8 19.3-11.4 19.3-18.8s-6.8-14-19.3-18.8zM92.5 14.7c4.1 2.4 5.5 9.8 3.8 20.3-.3 2.1-.8 4.3-1.4 6.6-5.2-1.2-10.7-2-16.5-2.5-3.4-4.8-6.9-9.1-10.4-13 7.4-7.3 14.9-12.3 21-12.3 1.3 0 2.5.3 3.5.9zM81.3 74c-1.8 3.2-3.9 6.4-6.1 9.6-3.7.3-7.4.4-11.2.4-3.9 0-7.6-.1-11.2-.4-2.2-3.2-4.2-6.4-6-9.6-1.9-3.3-3.7-6.7-5.3-10 1.6-3.3 3.4-6.7 5.3-10 1.8-3.2 3.9-6.4 6.1-9.6 3.7-.3 7.4-.4 11.2-.4 3.9 0 7.6.1 11.2.4 2.2 3.2 4.2 6.4 6 9.6 1.9 3.3 3.7 6.7 5.3 10-1.7 3.3-3.4 6.6-5.3 10zm8.3-3.3c1.5 3.5 2.7 6.9 3.8 10.3-3.4.8-7 1.4-10.8 1.9 1.2-1.9 2.5-3.9 3.6-6 1.2-2.1 2.3-4.2 3.4-6.2zM64 97.8c-2.4-2.6-4.7-5.4-6.9-8.3 2.3.1 4.6.2 6.9.2 2.3 0 4.6-.1 6.9-.2-2.2 2.9-4.5 5.7-6.9 8.3zm-18.6-15c-3.8-.5-7.4-1.1-10.8-1.9 1.1-3.3 2.3-6.8 3.8-10.3 1.1 2 2.2 4.1 3.4 6.1 1.2 2.2 2.4 4.1 3.6 6.1zm-7-25.5c-1.5-3.5-2.7-6.9-3.8-10.3 3.4-.8 7-1.4 10.8-1.9-1.2 1.9-2.5 3.9-3.6 6-1.2 2.1-2.3 4.2-3.4 6.2zM64 30.2c2.4 2.6 4.7 5.4 6.9 8.3-2.3-.1-4.6-.2-6.9-.2-2.3 0-4.6.1-6.9.2 2.2-2.9 4.5-5.7 6.9-8.3zm22.2 21l-3.6-6c3.8.5 7.4 1.1 10.8 1.9-1.1 3.3-2.3 6.8-3.8 10.3-1.1-2.1-2.2-4.2-3.4-6.2zM31.7 35c-1.7-10.5-.3-17.9 3.8-20.3 1-.6 2.2-.9 3.5-.9 6 0 13.5 4.9 21 12.3-3.5 3.8-7 8.2-10.4 13-5.8.5-11.3 1.4-16.5 2.5-.6-2.3-1-4.5-1.4-6.6zM7 64c0-4.7 5.7-9.7 15.7-13.4 2-.8 4.2-1.5 6.4-2.1 1.6 5 3.6 10.3 6 15.6-2.4 5.3-4.5 10.5-6 15.5C15.3 75.6 7 69.6 7 64zm28.5 49.3c-4.1-2.4-5.5-9.8-3.8-20.3.3-2.1.8-4.3 1.4-6.6 5.2 1.2 10.7 2 16.5 2.5 3.4 4.8 6.9 9.1 10.4 13-7.4 7.3-14.9 12.3-21 12.3-1.3 0-2.5-.3-3.5-.9zM96.3 93c1.7 10.5.3 17.9-3.8 20.3-1 .6-2.2.9-3.5.9-6 0-13.5-4.9-21-12.3 3.5-3.8 7-8.2 10.4-13 5.8-.5 11.3-1.4 16.5-2.5.6 2.3 1 4.5 1.4 6.6zm9-15.6c-2 .8-4.2 1.5-6.4 2.1-1.6-5-3.6-10.3-6-15.6 2.4-5.3 4.5-10.5 6-15.5 13.8 4 22.1 10 22.1 15.6 0 4.7-5.8 9.7-15.7 13.4z"/></g></svg>
                                           </span>
                                           <span className="tech-span">
                                            <img className="tech-image tech-icon" src="https://spline.design/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fspline_logo.647803e0.png&w=64&q=75"   title="Spline" />
                                            </span>
                            </div>
                            <div className="link small">
                                <a target="blank" href="https://spline-learning-60031592404.development.catalystserverless.in/app/index.html"  > {`->`} View</a>
                            </div>
                      
                        </div>
                    </div>
                 
                </div>
                <div className="work-samples">
                    <div className="sample-card ulta">
                      
                        <div className="content reveal">
                            <div className="title bold">
                                Netflix Clone
                            </div>
                            <div className="text light">
                            I've developed a Netflix clone using Angular, showcasing a design that replicates the streaming platform's interface. This project combines sleek, interactive elements with dynamic content display, blending technical skill with creative design to enhance user experience.                            </div>
                            <div className="techs-images">
                                            <span title="React" className="tech-span">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="tech-image tech-icon"  shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 114.4 122.88">
                <path fill="#DD0031" d="M57.2,0 L0,20.4 L8.72,96.03 L57.2,122.88 L105.68,96.03 L114.4,20.4 Z"/>
                <path fill="#C3002F" d="M57.2,0 L57.2,13.64 L57.2,75.82 L57.2,122.88 L105.68,96.03 L114.4,20.4 Z"/>
                <path fill="#FFFFFF" d="M57.2,13.58 L21.44,93.76 H34.77 L41.96,75.82 H72.31 L79.5,93.76 H92.83 L57.2,13.58 Z M67.65,64.76 H46.76 L57.2,39.63 L67.65,64.76 Z"/>
            </svg>                                           </span>
                                          
                            </div>
                            <div className="link small">
                                <a target="blank" href="https://netflixclone-60031592404.development.catalystserverless.in/app/index.html"  > {`->`} View</a>
                            </div>
                      
                        </div>
                        <div className="image reveal">
                            <a target="blank" href="https://netflixclone-60031592404.development.catalystserverless.in/app/index.html" >
                        <img src={rebelmoon}></img></a>
                        </div>
                    </div>
                 
                </div>
        </div>
        </div>
    );
};

export default Technology;
